import { saveProjectToCache } from './cache.ts';
import { generateCardImages } from './card-drawing.ts';
import { App } from './components/app.tsx';
import { SPREADSHEET_CONTENT_STORAGE_KEY, SPREADSHEET_URL_STORAGE_KEY } from './constants.ts';
import { fetchGoogleSpreadsheet, SpreadsheetData } from './google-docs-api.ts';
import { LocalStorage } from './local-storage.ts';
import { parseSpreadsheet } from './spreadsheet-parsing.ts';

export async function onPreviewCards(useCache: boolean = false) {
    let isDebug = location.hostname === 'localhost';
    let url: string = App.instance.state.spreadsheetUrl;
    let hasError = false;
    let hasCards = true;

    if (!url.startsWith('https://docs.google.com/spreadsheets/d/')) {
        alert(`Invalid spreadsheet URL.`);
        return;
    }

    LocalStorage.writeString(SPREADSHEET_URL_STORAGE_KEY, url);

    App.instance.setState({
        showCards: false
    });

    try {
        let spreadsheet: SpreadsheetData;

        if (useCache) {
            spreadsheet = LocalStorage.readObject(null, SPREADSHEET_CONTENT_STORAGE_KEY)!;
        } else {
            spreadsheet = await App.instance.runAction('Fetching spreadsheet', () => fetchGoogleSpreadsheet({ url }));

            if (isDebug) {
                LocalStorage.writeObject(SPREADSHEET_CONTENT_STORAGE_KEY, spreadsheet);
            }
        }
        console.log(spreadsheet);

        let project = await App.instance.runAction('Parsing spreadsheet', () => parseSpreadsheet(spreadsheet));
        console.log(project);

        let cards = await App.instance.runAction('Generating cards', () => generateCardImages(project, {
            imageLoader: App.instance.assetLoader,
            pdfQuality: false
        }));

        await App.instance.runAction('Saving to cache', () => saveProjectToCache(project));

        hasCards = cards.length > 0;

        App.instance.setState({
            spreadsheet,
            project,
            showCards: true,
            // justSaved: false
            hasCache: true,
            justSaved: true,
        });
    } catch (err: any) {
        hasError = true;

        if (err.result?.error?.message) {
            console.error(err);
            alert(err.result.error.message);
        } else if (typeof err === 'string') {
            console.error(err);
            alert(err);
        } else {
            throw err;
        }
    }

    if (!hasError && !hasCards) {
        setTimeout(() => alert(`No card to generate!`), 100);
    }
};